import React from 'react'
import { Helmet } from 'react-helmet-async'
function Terms_page() {
  const canonicalUrl =
    'https://www.internselite.net/Privacy-Policy/Refund-Policy'
  return (
    <div>
      <Helmet>
        <title>Privacy Policy | InternsElite: Your Privacy Matters</title>
        <meta
          name="description"
          content="Read InternsElites Privacy Policy to understand how we protect your personal information. We are committed to safeguarding your data and ensuring your privacy while you use our services. Learn about our data collection, usage, and protection practices."
        />
        <meta
          name="keywords"
          content="privacy policy, data protection, user privacy, online security, personal information, data privacy"
        />
        <meta
          property="og:title"
          content="Privacy Policy | InternsElite: Your Privacy Matters"
        />
        <meta
          property="og:description"
          content="Discover InternsElite, your gateway to professional growth with top-notch online internships and professional courses. We offer comprehensive training programs in Machine Learning, AI, Web Development, and more, with certification and placement support. Learn from industry experts and gain practical skills to excel in your career."
        />
        <meta
          property="og:url"
          content="https://internselite.net/Privacy-Policy/Refund-Policy"
        />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@internselite" />
        <meta
          name="twitter:title"
          content="Privacy Policy | InternsElite: Your Privacy Matters"
        />
        <meta
          name="twitter:description"
          content="Read InternsElites Privacy Policy to understand how we protect your personal information. We are committed to safeguarding your data and ensuring your privacy while you use our services. Learn about our data collection, usage, and protection practices."
        />
        <meta
          name="twitter:image"
          content="https://internselite.net/static/media/logo.c1eb8ff81ef75599f376.png"
        />
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>
      <div className="detail_1stcomp_img">
        <div className="container mt-5">
          <div className="Container">
            <div className="text-center pt-5 Terms_Discraption_text">
              <h1 className="display-5 pt-5">Privacy Policy</h1>
              <h2 className="fs-5 text-end py-2 border-bottom">
                Effective Date: 01-Jan-2023
              </h2>
              <p className="pt-2">
                At InternsElite, accessible from https://internselite.net/, one
                of our main priorities is the privacy of our visitors. This
                Privacy Policy document contains types of information that is
                collected and recorded by InternsElite and how we use it. If you
                have additional questions or require more information about our
                Privacy Policy, do not hesitate to contact us. This Privacy
                Policy applies only to our online activities and is valid for
                visitors to our website with regards to the information that
                they shared and/or collect in InternsElite. This policy is not
                applicable to any information collected offline or via channels
                other than this website.
              </p>
            </div>
          </div>
        </div>
        <div className="container pt-4">
          <div className="Container">
            <div className="text-center Terms_Discraption_text">
              <h2 className="display-6  pb-2">Consent</h2>
              <p className="">
                By using our website, you hereby consent to our Privacy Policy
                and agree to its terms. Information we collect The personal
                information that you are asked to provide, and the reasons why
                you are asked to provide it, will be made clear to you at the
                point we ask you to provide your personal information. If you
                contact us directly, we may receive additional information about
                you such as your name, email address, phone number, the contents
                of the message and/or attachments you may send us, and any other
                information you may choose to provide. When you register for an
                Account, we may ask for your contact information, including
                items such as name, company name, address, email address, and
                telephone number.
              </p>
            </div>
          </div>
        </div>
        <div className="container Terms_Discraption_text">
          <div className="row">
            <div className="container mt-5">
              <div className="">
                <h2 className="fs-2">How we use your information</h2>
                <p className="fs-6">
                  We use the information we collect in various ways, including
                  to:
                </p>
              </div>
              <ul className="">
                <li className="mt-3 fs-6">
                  Provide, operate, and maintain our website
                </li>
                <li className="mt-3 fs-6">
                  Improve, personalise, and expand our website
                </li>
                <li className="mt-3 fs-6">
                  Understand and analyse how you use our website
                </li>
                <li className="mt-3 fs-6">
                  Develop new products, services, features, and functionality
                </li>
                <li className="mt-3 fs-6">
                  Communicate with you, either directly or through one of our
                  partners, including for customer service, to provide you with
                  updates and other information relating to the website, and for
                  marketing and promotional purposes
                </li>
                <li className="mt-3 fs-6">Send you emails</li>
                <li className="mt-3 fs-6">Find and prevent fraud</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="container ">
          <div className="Container">
            <div className="text-center Terms_Discraption_text">
              <h2 className="fs-2 pb-2">Log Files</h2>
              <p className="">
                InternsElite follows a standard procedure of using log files.
                These files log visitors when they visit websites. All hosting
                companies do this and a part of hosting services' analytics. The
                information collected by log files include internet protocol
                (IP) addresses, browser type, Internet Service Provider (ISP),
                date and time stamp, referring/exit pages, and possibly the
                number of clicks. These are not linked to any information that
                is personally identifiable. The purpose of the information is
                for analysing trends, administering the site, tracking users'
                movement on the website, and gathering demographic information.
              </p>
            </div>
          </div>
        </div>
        <div className="container pt-4">
          <div className="Container">
            <div className="text-center Terms_Discraption_text">
              <h2 className="fs-2 pb-2">Google DoubleClick DART Cookie</h2>
              <p className="">
                Google is one of a third-party vendor on our site. It also uses
                cookies, known as DART cookies, to serve ads to our site
                visitors based upon their visit to www.website.com and other
                sites on the internet. However, visitors may choose to decline
                the use of DART cookies by visiting the Google ad and content
                network Privacy Policy at the following URL –
                <span className="fw-bold">
                  https://policies.google.com/technologies/ads
                </span>
              </p>
            </div>
          </div>
        </div>
        <div className="container pt-4">
          <div className="Container">
            <div className="text-center Terms_Discraption_text">
              <h2 className="fs-2 pb-2">
                Advertising Partners Privacy Policies
              </h2>
              <p className="">
                You may consult this list to find the Privacy Policy for each of
                the advertising partners of InternsElite. Third-party ad servers
                or ad networks uses technologies like cookies, JavaScript, or
                Web Beacons that are used in their respective advertisements and
                links that appear on InternsElite, which are sent directly to
                users' browser. They automatically receive your IP address when
                this occurs. These technologies are used to measure the
                effectiveness of their advertising campaigns and/or to
                personalise the advertising content that you see on websites
                that you visit. Note that InternsElite has no access to or
                control over these cookies that are used by third-party
                advertisers.
              </p>
            </div>
          </div>
        </div>
        <div className="container pt-4">
          <div className="Container">
            <div className="text-center Terms_Discraption_text">
              <h2 className="fs-2 pb-2">Third Party Privacy Policies</h2>
              <p className="">
                InternsElite's Privacy Policy does not apply to other
                advertisers or websites. Thus, we are advising you to consult
                the respective Privacy Policies of these third-party ad servers
                for more detailed information. It may include their practices
                and instructions about how to opt-out of certain options. You
                can choose to disable cookies through your individual browser
                options. To know more detailed information about cookie
                management with specific web browsers, it can be found at the
                browsers' respective websites.
              </p>
            </div>
          </div>
        </div>
        <div className="container Terms_Discraption_text">
          <div className="row">
            <div className="container mt-5">
              <div className="">
                <h2 className="fs-2">
                  CCPA Privacy Rights (Do Not Sell My Personal Information)
                </h2>
                <p className="fs-5">
                  Under the CCPA, among other rights, California consumers have
                  the right to:
                </p>
              </div>
              <ul className="">
                <li className="mt-3 fs-6">
                  Request that a business that collects a consumer's personal
                  data disclose the categories and specific pieces of personal
                  data that a business has collected about consumers.
                </li>
                <li className="mt-3 fs-6">
                  Request that a business delete any personal data about the
                  consumer that a business has collected.
                </li>
                <li className="mt-3 fs-6">
                  Request that a business that sells a consumer's personal data,
                  not sell the consumer's personal data.
                </li>
                <li className="mt-3 fs-6">
                  If you make a request, we have one month to respond to you. If
                  you would like to exercise any of these rights, please contact
                  us.
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="container Terms_Discraption_text">
          <div className="row">
            <div className="container mt-5">
              <div className="">
                <h2 className="fs-2">GDPR Data Protection Rights</h2>
                <p className="fs-5">
                  We would like to make sure you are fully aware of all of your
                  data protection rights. Every user is entitled to the
                  following:
                </p>
              </div>
              <ul className="">
                <li className="mt-3 fs-6">
                  The right to access – You have the right to request copies of
                  your personal data. We may charge you a small fee for this
                  service.
                </li>
                <li className="mt-3 fs-6">
                  The right to rectification – You have the right to request
                  that we correct any information you believe is inaccurate. You
                  also have the right to request that we complete the
                  information you believe it is incomplete.
                </li>
                <li className="mt-3 fs-6">
                  The right to erasure – You have the right to request that we
                  erase your personal data, under certain conditions.
                </li>
                <li className="mt-3 fs-6">
                  The right to restrict processing – You have the right to
                  request that we restrict the processing of your personal data,
                  under certain conditions.
                </li>
                <li className="mt-3 fs-6">
                  The right to object to processing – You have the right to
                  object to our processing of your personal data, under certain
                  conditions.
                </li>
                <li className="mt-3 fs-6">
                  The right to data portability – You have the right to request
                  that we transfer the data that we have collected to another
                  organisation, or directly to you, under certain conditions.
                </li>
                <li className="mt-3 fs-6">
                  If you make a request, we have one month to respond to you. If
                  you would like to exercise any of these rights, please contact
                  us.
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="container pt-4">
          <div className="Container">
            <div className="Terms_Discraption_text">
              <h2 className="fs-2 pb-2">Children's Information</h2>
              <p className="">
                Another part of our priority is adding protection for children
                while using the internet. We encourage parents and guardians to
                observe, participate in, and/or monitor and guide their online
                activity. InternsElite does not knowingly collect any Personal
                Identifiable Information from children under the age of 13. If
                you think that your child provided this kind of information on
                our website, we strongly encourage you to contact us immediately
                and we will do our best efforts to promptly remove such
                information from our records.
              </p>
            </div>
          </div>
        </div>
        <div className="container pt-4">
          <div className="Container">
            <div className="Terms_Discraption_text">
              <h2 className="fs-2 pb-2">Changes to This Privacy Policy</h2>
              <p className="">
                We may update our Privacy Policy from time to time. Thus, we
                advise you to review this page periodically for any changes. We
                will notify you of any changes by posting the new Privacy Policy
                on this page. These changes are effective immediately, after
                they are posted on this page.
              </p>
            </div>
          </div>
        </div>
        <div className="container pt-4">
          <div className="Container">
            <div className="Terms_Discraption_text">
              <h2 className="fs-2 pb-2">Contact Us</h2>
              <p className="">
                If you have any questions or suggestions about our Privacy
                Policy, do not hesitate to contact us.
              </p>
            </div>
          </div>
        </div>
        <div className="container pt-3">
          <div className="Container">
            <div className="Terms_Discraption_text">
              <h2 className="display-6 pb-4 text-center">Refund Policy</h2>
              <h2 className="fs-2 pb-2">Agreement to Payment Terms</h2>
              <p className="">
                By enrolling in an online or blended learning course or
                purchasing any services from InternsElite and providing payment
                information, you agree to the following payment terms. To
                purchase services or products from InternsElite, you must have
                internet access and a valid accepted payment method ("Payment
                Method"). You agree to allow InternsElite or its third-party
                payment provider to store and access your payment information.
                You also agree to pay the applicable fees for the services or
                products you purchase as they become due, whether on a one-time,
                installment, or subscription basis. Fees may vary based on your
                location, payment method, where your payment method was issued,
                or other contractual arrangements. Transactions may be subject
                to foreign exchange fees or differences in prices due to
                exchange rates. InternsElite does not support all payment
                methods, currencies, or locations for payment and may vary such
                offerings from time to time. Not all promotions and pricing are
                available to all students, and specific additional terms and
                conditions may apply to certain promotional programs, pricing,
                or geographic locations. You agree to use your valid payment
                method and not impersonate or use a payment method to avoid
                regulatory restrictions.
              </p>
            </div>
            <div className="Terms_Discraption_text pt-3">
              <h2 className="fs-2 pb-2">Personal Information Collection</h2>
              <p className="">
                Company collects information in several ways. When you register
                for a course, we may ask for contact information such as your
                name, address, telephone number, and email address, and for
                billing information. We may also ask you to complete forms or
                surveys that gather information about you, your academic
                background, business, profession, job, and opinions or comments.
                Correspondence sent to us by you or by third parties about your
                activities may be collected into a file specific to you.
              </p>
            </div>
            <div className="Terms_Discraption_text pt-3">
              <h2 className="fs-2 pb-2">Taxes</h2>
              <p className="">
                When you purchase any online or blended learning course or other
                service or product from InternsElite, you agree to pay not only
                the applicable fee but also all applicable sales, use,
                value-added, transaction taxes, or other government-required
                fees and charges that InternsElite determines it is required to
                collect ("Taxes"). All applicable taxes are calculated based on
                the billing information you provide at the time of purchase. You
                authorize InternsElite to modify and charge any taxes owed by
                you upon confirming the tax rate. Where GST/VAT collection is
                required, it will be calculated and added at checkout. You agree
                to indemnify and hold InternsElite harmless against any claims
                by any tax authority for any underpayment of taxes, including,
                without limitation, GST/VAT, and any related penalties and/or
                interest.
              </p>
            </div>
            <div className="Terms_Discraption_text pt-3">
              <h2 className="fs-2 pb-2">Refunds</h2>
              <p className="">
                InternsElite will not offer refunds on any fees and charges
                related to your purchase of any products or services. This
                includes any partially used or unused periods for which you have
                already paid, regardless of whether it is a subscription,
                bundled, manual subscription, one-time term payment method, or
                slot booking fee. We do not guarantee refunds for lack of usage
                or dissatisfaction. InternsElite disclaims any responsibility or
                liability related to any third-party marketplace’s refund policy
                or the third party’s compliance or noncompliance with such a
                policy.
              </p>
            </div>
            <div className="Terms_Discraption_text pt-3">
              <h2 className="fs-2 pb-2">Reason for No Refunds</h2>
              <p className="">
                After registration, students are provided with a
                traineeship/internship letter, which commits resources and
                opportunities to the student, making it impractical to offer
                refunds.
              </p>
            </div>
            <div className="Terms_Discraption_text pt-3">
              <h2 className="fs-2 pb-2">Transfer of Registration</h2>
              <p className="">
                If students do not wish to continue after slot booking, they can
                transfer the registration to other eligible student by
                contacting our support number or by reaching out to our email id{' '}
                <a href="mailto:support@internselite.com">
                  support@internselite.com
                </a>{' '}
                The transferee must be contacted within the company and able to
                proceed with the program.
              </p>
            </div>
          </div>
        </div>
        <div className="container py-4">
          <div className="Container">
            <div className="Terms_Discraption_text">
              <h2 className="fs-2 pb-2">Contact Information</h2>
              <p className="">
                If you have any questions or concerns regarding our refund
                policy, please contact us at{' '}
                <a href="mailto:support@internselite.com">
                  support@internselite.com
                </a>
                ,<a href="tel:+919318338245">+91 93183 38245</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Terms_page
